import React from 'react'
import './Link.scss'
import {Link as RouterLink} from 'gatsby'

export default function Link({url, title, target, type = 'normal', color}) {
	return(
		<RouterLink to={url} target={target} className={`Link ${type} ${color}`}>
			{title}
			{
				type === 'arrow'
				? 	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.011 20.951">
						<g>
							<path d="M37.759,23.354l-7.88-7.88,2.6-2.6L42.95,23.354,32.475,33.83l-2.6-2.6Z" transform="translate(-18.94 -12.879)" fillRule="evenodd"/>
							<path d="M12,27H32.191v3.671H12Z" transform="translate(-12 -18.36)" />
						</g>
					</svg>
				: null
			}
		</RouterLink>
	)
}